import ToppingMenu from '../ToppingMenu/topping-menu';

export default ToppingMenu;